import { IBrand } from '../../../main/entities';
import { mg } from '../../../mg/mg';

interface INameSearchElement {
	type: 'STRING' | 'WORD_START' | 'WORD'
	string: string
}

function escapeRegex(regex: string) : string {
	return regex.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
}

function elementToRegex(e: INameSearchElement) : string {
	const r = escapeRegex(e.string);
	switch (e.type) {
	case 'STRING': return r;
	case 'WORD_START': return '\\b' + r;
	case 'WORD': return '\\b' + r + '\\b';
	}
}

function arrayToRegex(a: Array<INameSearchElement>) {
	return a.map(e => elementToRegex(e)).join('|');
}

export function filterOnBrandFn<E extends {name: string}>(brand?: IBrand) : ((e: E) => boolean) {
	if (!brand) return () => true;
	const nameSearch: {elements: Array<INameSearchElement>} = mg.parseJson(brand.nameSearchJson);
	const r = new RegExp(arrayToRegex(nameSearch.elements), 'i');
	return (e) => r.test(e.name);
}
